import React, { useRef } from 'react';

export interface IChip {
  text: string | null;
  isSelected?: boolean;
  classnames?: string;
  onClick?: (text: string) => void;
  onDoubleClick?: (text: string) => void;
}
const Chip = (props: IChip) => {
  const { text, isSelected = false, onClick, classnames = '', onDoubleClick } = props;
  const timer = useRef<NodeJS.Timeout | null>(null);
  const stringText = text ? text.toString() : 'None';

  const handleClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    clearTimeout(timer.current);
    if (event.detail === 1) {
      timer.current = setTimeout(() => {
        onClick(text);
      }, 250);
    } else if (event.detail === 2) {
      onDoubleClick(text);
    }
  };

  return (
    <div id={`chip-${stringText}-wrapper`}
      onClick={handleClick}
      className={`h-[30px] max-w-[84%] rounded-[16px] select-none border border-[#888888] font-normal text-[#313131] cursor-pointer hover:border-gray-500  ${
        isSelected ? 'bg-[#bfbfbf] ' : ''
      } ${classnames} py-[3px] px-[12px]`}
      title={stringText}
    >
      <label id={`chip-${stringText}-label`} className="max-w-[100%] truncate cursor-pointer">{stringText}</label>
    </div>
  );
};

export default Chip;
